function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { unorderedItems } from "../Organisms/PageContent/BlockMarkup";
export function Messages(props) {
    var _useState = _sliced_to_array(useState([]), 2), displayMessages = _useState[0], setDisplayMessages = _useState[1];
    var _React_useState = _sliced_to_array(React.useState([]), 2), messageComponents = _React_useState[0], setMessageComponents = _React_useState[1];
    useEffect(function() {
        setDisplayMessages(props.messages);
        props.messageComponents && setMessageComponents(props.messageComponents);
    }, [
        props.messages
    ]);
    var handleRemoveMessage = function(index) {
        var newMessages = displayMessages.filter(function(_, i) {
            return i !== index;
        });
        setDisplayMessages(newMessages);
        storeMessages(newMessages);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, buildMessages(displayMessages, handleRemoveMessage), buildMessages(messageComponents)));
}
export var buildMessages = function(messages, handleRemoveMessage) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, messages.map(function(message, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "flex items-center p-5 my-6 rounded-lg border-l-4 border-theme-dark bg-white text-theme-dark shadow-md",
            role: "alert",
            "aria-live": "polite"
        }, /*#__PURE__*/ React.createElement("svg", {
            className: "mr-3 shrink-0 w-4 h-4",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "currentColor",
            viewBox: "0 0 20 20"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
        })), /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, "Info"), /*#__PURE__*/ React.createElement("div", {
            className: "text-sm font-medium prose-a:font-semibold prose-a:underline"
        }, typeof message === "string" ? /*#__PURE__*/ React.createElement(Html, {
            key: index,
            markup: message,
            plugins: [
                unorderedItems
            ],
            components: {
                li: function(_param) {
                    var unordered = _param.unordered, children = _param.children, className = _param.className, props = _object_without_properties(_param, [
                        "unordered",
                        "children",
                        "className"
                    ]);
                    return /*#__PURE__*/ React.createElement("li", _object_spread_props(_object_spread({}, props), {
                        className: clsx(className, {
                            "!text-theme-dark ml-5 mt-1 mb-1 list-disc messages text-sm font-medium": unordered
                        })
                    }), children);
                }
            }
        }) : message), handleRemoveMessage && /*#__PURE__*/ React.createElement("button", {
            type: "button",
            className: "ms-auto -m-1.5 bg-white text-theme-dark rounded-lg focus:ring-2 focus:ring-theme-med p-1.5 hover:bg-grey inline-flex items-center justify-center h-8 w-8",
            "data-dismiss-target": "#alert-".concat(index + 1),
            onClick: function() {
                return handleRemoveMessage(index);
            },
            "aria-label": "Close message ".concat(index + 1)
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, "Close"), /*#__PURE__*/ React.createElement("svg", {
            className: "w-3 h-3",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 14 14"
        }, /*#__PURE__*/ React.createElement("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        }))));
    }));
};
export var storeMessages = function(messages) {
    localStorage.setItem("messages", JSON.stringify(messages));
};
export var readMessages = function() {
    var serialized = localStorage.getItem("messages");
    localStorage.removeItem("messages");
    if (serialized) {
        try {
            var messages = JSON.parse(serialized);
            if (Array.isArray(messages) && messages.every(function(message) {
                return typeof message === "string";
            })) {
                return messages;
            }
        } catch (e) {
            return [];
        }
    }
    return [];
};
